import React, { useEffect, useState } from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

import { metricValueFormat } from '../../utils/metricValueFormat';
import './metricMonthlyClientKPICard.scss';
import trendDown from '../../assets/trendDown.svg';
import trendUp from '../../assets/trendUp.svg';
import targetArrow from '../../assets/targetArrow.svg';
import { MetricColors } from './GradientDefs';
import MetricMetIcon from '../../assets/DisputeReviewedIcon.svg';
import MetricNotMetIcon from '../../assets/DisputedIcon.svg';

type metricProps = {
    metricNameVal?: string;
    targetVal: number;
    metricTypeName: string;
    metricAttained?: boolean;
    metricVal: number;
    metricDirectionId?: number;
    selectedMetric?: string;
    index?: number;
    clientTargetVal?: number;
};
export const MetricMonthlyClientKPICard = ({
    metricNameVal,
    targetVal,
    metricVal,
    metricTypeName,
    metricAttained,
    metricDirectionId,
    selectedMetric,
    index,
    clientTargetVal,
}: metricProps) => {
    const [strClientTargetValue, setClientTargetValue] = useState('');
    const [strScorecardMetricValue, setStrScorecardMetricValue] = useState('');
    const [strScorecardTargetValue, setStrScorecardTargetValue] = useState('');
    const [selectedMetricBackgrndColor, setSelectedMetricBackgrndColor] = useState('#000000');
    const [innerCircleMinValue, setInnerCircleMinValue] = useState(0);
    const [outerCircleMinValue, setOuterCircleMinValue] = useState(0);
    const [innerCircleMaxValue, setInnerCircleMaxValue] = useState(100);
    const [outerCircleMaxValue, setOuterCircleMaxValue] = useState(100);

    const cTextColor = metricAttained ? '#2AA154' : '#C90370';
    let clientTargetReached = false;
    if (clientTargetVal !== undefined && clientTargetVal !== null)
        clientTargetReached = metricDirectionId === 1 ? metricVal >= clientTargetVal : metricVal <= clientTargetVal;
    let scorecardTargetReached = false;
    if (targetVal !== undefined && targetVal !== null)
        scorecardTargetReached = metricDirectionId === 1 ? metricVal >= targetVal : metricVal <= targetVal;
    const metricOmitted = metricVal == null;


    const formatAndSetScorecardTarget = () => {
        if (targetVal === null) {
            setStrScorecardTargetValue('--');
        } else {
            const targetValue = metricValueFormat(targetVal, metricTypeName);
            setStrScorecardTargetValue(targetValue);
        }
    };

    const formatAndSetMetricValue = () => {
        if (metricVal === null || metricOmitted) {
            setStrScorecardMetricValue('--');
        }
        else {
            const metricValue = metricValueFormat(metricVal, metricTypeName);
            setStrScorecardMetricValue(metricValue);
        }
    };
    const formatAndSetClientTargetcValue = () => {
        if (metricOmitted) {
            setClientTargetValue('--');
        }
        else if (clientTargetVal === null || clientTargetVal === undefined) {
            setClientTargetValue('NOT AVAILABLE');
        }
        else {
            const metricValue = metricValueFormat(clientTargetVal, metricTypeName);
            setClientTargetValue(metricValue);
        }
    };
    useEffect(() => {
        const colors = MetricColors[safeIndex];
        setSelectedMetricBackgrndColor(colors.bgColor);

        formatAndSetScorecardTarget();
        formatAndSetMetricValue();
        formatAndSetClientTargetcValue();

        if (metricOmitted) {
            setInnerCircleMinValue(0);
            setInnerCircleMaxValue(100);
            setOuterCircleMinValue(0);
            setOuterCircleMaxValue(100);
        }
        else {
            // Handle outer circle (client target)
            if (clientTargetVal != null && metricVal != null) {
                if (metricDirectionId === 2 && clientTargetReached) {
                    setOuterCircleMinValue(100);
                    setOuterCircleMaxValue(10);
                }
                else {
                    setOuterCircleMinValue(metricVal);
                    setOuterCircleMaxValue(clientTargetVal);
                }
            }
            else if (clientTargetVal == null && metricVal != null) {
                setOuterCircleMinValue(0);
                setOuterCircleMaxValue(100);
            }

            // Handle inner circle (scorecard target)
            if (targetVal != null && metricVal != null) {
                if (metricDirectionId === 2 && scorecardTargetReached) {
                    setInnerCircleMinValue(100);
                    setInnerCircleMaxValue(10);
                }
                else {
                    setInnerCircleMinValue(metricVal);
                    setInnerCircleMaxValue(targetVal);
                }
            }
            else if (targetVal == null && metricVal != null) {
                setInnerCircleMinValue(0);
                setInnerCircleMaxValue(100);
            }

            // Handle case when metricVal is missing
            if (metricVal == null) {
                setInnerCircleMinValue(0);
                setInnerCircleMaxValue(100);
                setOuterCircleMinValue(0);
                setOuterCircleMaxValue(100);
            }
        }
    }, [metricTypeName, metricVal, metricNameVal, targetVal, clientTargetVal, metricOmitted]);

    const safeIndex = (index ?? 0) % MetricColors.length;
    const gradientId = `gradientId${safeIndex}`;
    const outerCircleGradientId = `gradientId${MetricColors[safeIndex].outerCircleColorId}`;
    // const outerCircleGradientId = `gradientId${MetricColors[index ?? 0].outerCircleColorId}`;

    // Two concentric circular progress bars
    const circularprogressbar = (
        <div style={{ position: 'relative', width: '135px', height: '135px' }}>
            {/* Outer circle - Target (shows as a full reference ring) */}
            <div style={{ position: 'absolute', width: '135px', height: '135px' }}>
                <CircularProgressbar
                    maxValue={outerCircleMaxValue}
                    styles={buildStyles({
                        textColor: cTextColor,
                        pathColor: `url(#${outerCircleGradientId})`,
                        trailColor: '#E0E0E0',
                        pathTransition: "none"
                    })}
                    value={outerCircleMinValue}  // Full circle as target reference
                    strokeWidth={15}
                />
            </div>

            {/* Inner circle - Actual Value */}
            <div style={{ position: 'absolute', width: '90px', height: '90px', top: '22px', left: '22px' }}>
                <CircularProgressbar
                    maxValue={innerCircleMaxValue}
                    styles={buildStyles({
                        textColor: cTextColor,
                        pathColor: `url(#${gradientId})`,
                        trailColor: '#E0E0E0',
                        pathTransition: "none"
                    })}
                    value={innerCircleMinValue}
                    text={strScorecardMetricValue}
                    strokeWidth={15}
                />
            </div>
        </div>
    );

    return (
        <div
            className="col"
            role="button"
            tabIndex={0}
            style={{
                cursor: 'hand',
                border: '1px solid lightgray', paddingLeft: '0px', paddingRight: '0px', height: '100%', borderRadius: '8px'
            }}
        >
            <div className="rounded h-100" style={{
                backgroundColor: selectedMetric === metricNameVal ? selectedMetricBackgrndColor : 'transparent',
                cursor: 'pointer',
            }}>
                <div
                    className="card-body"
                    style={{
                        backgroundColor: selectedMetric === metricNameVal ? selectedMetricBackgrndColor : 'transparent',
                        cursor: 'pointer',
                    }}
                >
                    <div className="row">
                        <div className="col-11 align-top p-0">
                            <h6 className="card-title metricName mb-0 align-top ps-2">{metricNameVal}</h6>

                            <div className='ps-2 pt-2'>
                                {metricDirectionId && (<>
                                    <img src={metricDirectionId === 1 ? trendUp : trendDown} alt="trendUp" style={{ verticalAlign: 'sub', height: '18px' }} />
                                    <span className='metricDirection'>{metricDirectionId === 1 ? 'Ascending' : 'Descending'}</span></>
                                )}
                                {metricOmitted &&
                                    <span className={'MetricOmitted'} style={{ marginLeft: '120px', fontWeight: 'bold' }}>Omitted Metric</span>
                                }
                            </div>
                        </div>
                        {!metricOmitted && <div className="col-1 p-0">

                            <img className="justify-content-left " src={clientTargetReached ? MetricMetIcon : MetricNotMetIcon} alt="" />
                        </div>
                        }
                    </div>
                    <div className="row d-flex justify-content-center align-items-center mt-3">
                        <div
                            className="col-4"
                            style={{
                                width: '135px',
                                height: '135px',
                                padding: '3px',
                                boxSizing: 'border-box',
                                margin: '0 auto',
                                marginLeft: '15px'
                            }}
                        >
                            {circularprogressbar}
                        </div>
                        <div className="col-8" style={{ borderLeft: '1px solid lightgray' }}>
                            <div className='row'>
                                <div className='col-md-8'>
                                    <div className={`target_container  ${strScorecardTargetValue}`} style={{ color: !metricOmitted ? MetricColors[safeIndex].clientTargetTextColor : 'black', flexWrap: 'nowrap' }}>
                                        <span
                                            className="arrow-icon"
                                            style={{
                                                WebkitMaskImage: `url(${targetArrow})`,
                                                maskImage: `url(${targetArrow})`,
                                                backgroundColor: !metricOmitted ? MetricColors[safeIndex].clientTargetTextColor : 'black',
                                                flexShrink: 0
                                            }}
                                        />
                                        <span style={{ marginLeft: '4px', whiteSpace: 'nowrap' }}>
                                            Client Target : {!metricOmitted ? strClientTargetValue : '--'}
                                        </span>
                                    </div>
                                </div>
                                {!metricOmitted && clientTargetVal !== null && clientTargetVal !== undefined &&
                                    <div className='col-md-4 ps-0 pe-0' style={{ display: 'flex', alignItems: 'center' }}>
                                        <i className={clientTargetReached ? "pi pi-check metricMetIcon" : "pi pi-times metricNotMetIcon"} />
                                        <span className={clientTargetReached ? 'metricMet' : 'MetricNotMet'}>{clientTargetReached ? 'Metric Met' : 'Metric Not Met'}</span>
                                    </div>}
                            </div>
                            <div className='row pt-2'>
                                <div className='col-md-8'>
                                    <div className={`target_container  ${strScorecardTargetValue}`} style={{ color: !metricOmitted ? MetricColors[safeIndex].ScorecardTargetColor : 'black', flexWrap: 'nowrap' }}>
                                        <span
                                            className="arrow-icon"
                                            style={{
                                                WebkitMaskImage: `url(${targetArrow})`,
                                                maskImage: `url(${targetArrow})`,
                                                backgroundColor: !metricOmitted ? MetricColors[safeIndex].ScorecardTargetColor : 'black',
                                                flexShrink: 0
                                            }}
                                        />
                                        <span style={{ marginLeft: '4px', whiteSpace: 'nowrap' }}>
                                            Scorecard Target : {!metricOmitted ? strScorecardTargetValue : '--'}
                                        </span>
                                    </div>
                                </div>
                                {!metricOmitted &&
                                    <div className='col-md-4 ps-0 pe-0' style={{ display: 'flex', alignItems: 'center' }}>
                                        <i className={scorecardTargetReached ? "pi pi-check metricMetIcon" : "pi pi-times metricNotMetIcon"} />
                                        <span className={scorecardTargetReached ? 'metricMet' : 'MetricNotMet'}>{scorecardTargetReached ? 'Metric Met' : 'Metric Not Met'}</span>
                                    </div>
                                }
                            </div>
                            <div className='row pt-2'>
                                <div className='col-md-8'>
                                    <div className={`target_container ${strScorecardTargetValue}`} style={{ color: !metricOmitted ? MetricColors[safeIndex].ScorecardTargetColor : 'black', paddingLeft: '27px' }}>
                                        Actual : {!metricOmitted ? <div>{strScorecardMetricValue}</div> : <div> --</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};